import Login from "../components/Login"
import LostPassword from "../components/LostPassword"
import ResetPassword from "../components/ResetPassword"
import Verify from "../components/Verify"
import Logout from "../components/Logout"
import Disabled from "../components/Errors/Disabled";

export default [
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            fullscreen: true,
            requiresAuth: false
        }
    },
    {
        path: '/lost-password',
        name: 'lost-password',
        component: LostPassword,
        meta: {
            fullscreen: true,
            requiresAuth: false
        }
    },
    {
        path: '/reset-password/:token',
        name: 'reset-password',
        component: ResetPassword,
        meta: {
            fullscreen: true,
            requiresAuth: false
        }
    },
    {
        path: '/verify',
        name: 'verify',
        component: Verify,
        meta: {
            fullscreen: true,
            requiresAuth: true
        }
    },
    {
        path: '/disabled',
        name: 'disabled',
        component: Disabled,
        meta: {
            fullscreen: true,
            requiresAuth: false
        }
    },
    {
        path: '/logout',
        name: 'logout',
        component: Logout,
        meta: {
            fullscreen: true,
            requiresAuth: false
        }
    }
]